import type { ButtonProperties, ButtonType } from '../Button';

type GetButtonSettingsReturn = { color: ButtonProperties['color']; variant: ButtonProperties['variant'] };

type P = {
  danger?: boolean;
  type: ButtonType;
};

const buttonSettings: Record<ButtonType, GetButtonSettingsReturn> = {
  'link-inverted': { color: 'default', variant: 'link' },
  'link-primary': { color: 'primary', variant: 'link' },
  'link-secondary': { color: 'default', variant: 'link' },
  primary: { color: 'primary', variant: 'solid' },
  secondary: { color: 'primary', variant: 'filled' },
  tertiary: { color: 'default', variant: 'outlined' },
  text: { color: 'default', variant: 'text' },
  vertical: { color: 'default', variant: 'text' },
};

export const useGetButtonSettings = ({ danger, type }: P): GetButtonSettingsReturn => {
  const { color, variant } = buttonSettings[type];
  return {
    color: danger ? 'danger' : color,
    variant,
  };
};
